import { ChevronLeft } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'
import { StyleButtonIcon } from './style'

const BackButton = ({
  path,
  onClick,
}: {
  path?: string
  onClick?: () => void
}) => {
  return onClick ? (
    <StyleButtonIcon onClick={onClick} />
  ) : (
    <Link to={path}>
      <StyleButtonIcon />
    </Link>
  )
}

export default BackButton
